"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getLanguageFromHostname = function getLanguageFromHostname() {
  if (typeof window === "undefined") return undefined;
  var langDomains = global.__appConfig__.domainLanguages;
  var chosenLanguage = langDomains[window.location.hostname];
  if (chosenLanguage === undefined) {
    var fullUrl = window.location.href;
    var language = fullUrl.replace(/(https|http):\/\/[^\/]+\//, "");
    if (language.length > 0) {
      chosenLanguage = language;
    } else {
      Object.values(langDomains).every(function (lang) {
        if (fullUrl.includes("/" + lang + "/")) {
          chosenLanguage = lang;
          return false;
        }
        return true;
      });
    }
  }
  return chosenLanguage;
};
var _default = getLanguageFromHostname;
exports["default"] = _default;